import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ArticlePath, createGuideLink, RouteName, TextKey } from '@mews-commander/enums';
import { prefetchTasks, TasksContainer } from '@mews-commander/modules/src/modules/tasks';
import { MewsTeam, RouteType } from '@mews/enums';

const Component = () => (
    <TasksContainer
        key="create"
        serviceOrderId={Route.useSearch().serviceOrderId}
        guideLink={createGuideLink(ArticlePath.CreateManageTasks)}
    />
);

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Task/Create')({
    component: Component,
    validateSearch: z.object({
        serviceOrderId: z.string().optional(),
    }),
    loaderDeps: ({ search: { serviceOrderId } }) => ({ serviceOrderId }),
    loader: async ({ context: { dispatch__DO_NOT_USE_OR_YOU_WILL_BE_FIRED: dispatch }, deps: { serviceOrderId } }) => {
        await prefetchTasks(dispatch, { serviceOrderId });
    },
    staticData: {
        routeName: RouteName.TaskCreate,
        owner: MewsTeam.GroupsEvents,
        title: TextKey.Task,
        type: RouteType.Frontend,
    },
});
